﻿import React, { useState, useEffect, useRef, useContext } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import { GoogleLogin } from 'react-google-login';
import { gapi } from 'gapi-script';
import "./StickyFooter.css";
import Welcome from "./../../Home/Welcome/Welcome";
import googleImg from "./../../../Images/google-img.png";
import closeIcon from "./../../../Images/close-icon.png";
import { useSelector, useDispatch } from 'react-redux';
import { userSelector, clearState, signupUser, setState } from '../../features/User/UserSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from 'react-router-dom';
import LoginPopup from "../LoginPopup/LoginPopup";
import URLstateContext from "../../../provider/CommonContext";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faPhone  } from "@fortawesome/free-solid-svg-icons";
import RupeesFooter10 from "./../../../Images/New_Home/10-Rupees-Footer.png";
import ZeroAmcFooter from "./../../../Images/New_Home/zero-amcFooter.png";
import AccountOpenFooter from "./../../../Images/New_Home/Account-openFooter.png";
import AlgoTradingFooter from "./../../../Images/New_Home/algo-trading-Footer.png";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import Slider from "react-slick";
import axios from "axios";
import Swal from "sweetalert2";
import TrackApi from "../../Activity_Track/TrackApi";
import { useCookies } from "react-cookie";
import { ApiUrlDomain } from "../../Configration/Configrationnew";

function StickyFooter() {
    const crntpageurl = window.location.pathname;
    const { clientId } = useContext(URLstateContext);
    const ArrowRight = <FontAwesomeIcon icon={faArrowRight} />
    const UserIcon = <FontAwesomeIcon icon={faUser} />
    const EnvelopeIcon = <FontAwesomeIcon icon={faEnvelope} />
    const PhoneIcon = <FontAwesomeIcon icon={faPhone} />
     const EyeSlash = <FontAwesomeIcon icon={faEyeSlash } />
     const Eye = <FontAwesomeIcon icon={faEye } />
    const [show, setShow] = useState(false);
    const [userName, setUserName] = useState('');
    const [MobNumber, setMobNumber] = useState('');
    const [otpfieldenable,setotpfieldenable]=useState(false);
    const [newUserMoberror, setNewUserMoberror] = useState('');
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const childRef = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [OpenCtaformMobileshow, setShowOpenCtaformMobile] = useState(false);
    const OpenCtaformMobile = () => setShowOpenCtaformMobile(true);
    const CloseCtaformMobile = () => setShowOpenCtaformMobile(false);
    const [showpwdnew,setshowpwdnew] = useState(false);
    const [otpis1,setotpis1]=useState('');
    const [otpis2,setotpis2]=useState('');
    const [otpis3,setotpis3]=useState('');
    const [otpis4,setotpis4]=useState('');
    const [seconds, setSeconds] = useState(30);
    const [cookies, setCookie] = useCookies(['LeadId']);
const [resendDisabled, setResendDisabled] = useState(true);
    const usrname = useSelector(state => state.user.email);
    const { isFetching, isSuccess, isError, errorMessage, isCRMuser,ProspectStage,mx_Lead_Status,mx_Status } = useSelector(
        userSelector
    );
    
    const settings = {
        autoplay:true,
        dots: false,
        prevArrow: false,
        nextArrow: false,
        arrows: false,
        vertical: true,
        verticalSwiping: true,
        slidesToShow: 1,
        slidesToScroll: 1
      };
    useEffect(() => {
        if (isSuccess) {
            setShow(false);

        }
        if (isError) {

            // console.log(errorMessage);
            dispatch(clearState());
        }
    }, [isSuccess, isError]);

    const clickToggleLoginPopup = (showhide) => {
        childRef.current.changeTogglePopup(showhide);
    }
    const handleNewUserMobileNumber = event => {

        // if(event.target.value.length  == "" && event.target.value.length <= 10 ){
        //     document.getElementById('error').style.display ="block";
        // }
        // else{
        //     document.getElementById('error').style.display ="none";
        // }
        const re = /^[0-9\b]+$/;
        if (event.target.value.length <= 10 && re.test(event.target.value)) {
            setMobNumber(parseInt(event.target.value));
        }

        if (event.target.value.length == 0) {
            setMobNumber("");
        }
        setNewUserMoberror("");

    };
    const OtpSend=(e)=>{
        e.preventDefault();
       // otp send api call
       if (MobNumber != "" && MobNumber.toString().length === 10) {
        // setSeconds(30);
        //         setResendDisabled(true);
        //         setotpfieldenable(true);
        //         return;
        axios.get(`${ApiUrlDomain}/otpSend?phone_no=${MobNumber}`).then((res)=>{
            if(res.data=='OTP sent successfully'){
                setSeconds(30);
                setResendDisabled(true);
                setotpfieldenable(true);
        }
      
    }).catch((error)=>{
        console.log(error);
    })

        
       }else{
        setNewUserMoberror("Please enter valid mobile number");
            return false;
       }
       

    }
    const verifyOtp=(e)=>{
        e.preventDefault();
       // otp verify api call
       
   
      const fullOtp = otpis1 + otpis2 + otpis3 + otpis4;
      axios.get(`${ApiUrlDomain}/otpValidate?phone_no=${MobNumber}&otp=${fullOtp}`).then((res)=>{
  
  if(res.data=='OTP validated successfully'){

    axios.post(`${ApiUrlDomain}/signupRetriveLead`,{"phone":MobNumber}).then((res)=>{
        
            if(res && res.data.length>0){
        //     dispatch(setState({
        //         "email": MobNumber,
        // "name": userName,
        //         "ProspectStage": res.data[0].prospectStage,
        //         "mx_Lead_Status": res.data[0].mx_Lead_Status,
        //         "mx_Status": res.data[0].mx_Status
        //     }));  
        //     //  
        //     localStorage.setItem('userlogin',true);
        //     localStorage.setItem('email',MobNumber);
        //     localStorage.setItem('ProspectStage',res.data[0].prospectStage);
        //     localStorage.setItem('mx_Lead_Status',res.data[0].mx_Lead_Status);
        //     localStorage.setItem('mx_Status',res.data[0].mx_Status);
        //     localStorage.setItem('name',userName);
        //     localStorage.setItem('token',"jhjsdhjhjhd");
           
            const leadId=res.data[0].prospectID;
               setCookie('RelatedProspectId', leadId,{ path: '/',"maxAge": 2592000*3 });
               const payloadData={
                "RelatedProspectId":leadId,
                "ActivityNote": "Your Activity Note",
                "mx_Custom_1": "Home",
                "mx_Custom_2": "Your Activity Note",
                "mx_CustomObject_81":window.location.href
               }
            //    TrackApi(payloadData);
               if(res.data[0].prospectStage=="Customer" && res.data[0].mx_Lead_Status=="Active" && res.data[0].mx_Status=="Enabled"){
                dispatch(setState({
                    "email": MobNumber,
            "name": userName,
                    "ProspectStage": res.data[0].prospectStage,
                    "mx_Lead_Status": res.data[0].mx_Lead_Status,
                    "mx_Status": res.data[0].mx_Status
                }));  
                //  
                localStorage.setItem('userlogin',true);
                localStorage.setItem('email',MobNumber);
                localStorage.setItem('ProspectStage',res.data[0].prospectStage);
                localStorage.setItem('mx_Lead_Status',res.data[0].mx_Lead_Status);
                localStorage.setItem('mx_Status',res.data[0].mx_Status);
                localStorage.setItem('name',userName);
                localStorage.setItem('token',"jhjsdhjhjhd"); 
                TrackApi(payloadData);
                window.open('https://online.moneysukh.com');
               }else{
                // window.open('https://kyc.moneysukh.com');
                axios.post(`${ApiUrlDomain}/signupnewuser`,{Mobile:MobNumber,mx_Vendor_Unique_Id:res.data[0].mx_Vendor_Unique_Id}).then((resn)=>{
  
            dispatch(setState({
                "email": MobNumber,
        "name": userName,
                "ProspectStage": res.data[0].prospectStage,
                "mx_Lead_Status": res.data[0].mx_Lead_Status,
                "mx_Status": res.data[0].mx_Status
            }));  
            //  
            if(resn && resn.data && resn.data.uniqueid){
                axios.post(`${ApiUrlDomain}/lsqupdate`, {
                    "LeadId":leadId,
                    "mx_Vendor_Unique_Id":resn.data.uniqueid
                }).then((tt)=>{
        
                }).catch((errd)=>{
                    console.log(errd);
                })
            }

            localStorage.setItem('userlogin',true);
            localStorage.setItem('email',MobNumber);
            localStorage.setItem('ProspectStage',res.data[0].prospectStage);
            localStorage.setItem('mx_Lead_Status',res.data[0].mx_Lead_Status);
            localStorage.setItem('mx_Status',res.data[0].mx_Status);
            localStorage.setItem('name',userName);
            localStorage.setItem('token',"jhjsdhjhjhd"); 
        let redirecturlsignup = document.createElement('a');
        redirecturlsignup.href = resn.data.data[0].url;
        redirecturlsignup.target = '_blank';
        redirecturlsignup.style.display = 'none';
        document.body.appendChild(redirecturlsignup);
        redirecturlsignup.click();
        document.body.removeChild(redirecturlsignup); 
            TrackApi(payloadData);
            
}).catch((error)=>{
    // setverifyloader(false);
    dispatch(setState({
        "email": MobNumber,
"name": userName,
        "ProspectStage": res.data[0].prospectStage,
        "mx_Lead_Status": res.data[0].mx_Lead_Status,
        "mx_Status": res.data[0].mx_Status
    }));  
    //  
    localStorage.setItem('userlogin',true);
    localStorage.setItem('email',MobNumber);
    localStorage.setItem('ProspectStage',res.data[0].prospectStage);
    localStorage.setItem('mx_Lead_Status',res.data[0].mx_Lead_Status);
    localStorage.setItem('mx_Status',res.data[0].mx_Status);
    localStorage.setItem('name',userName);
    localStorage.setItem('token',"jhjsdhjhjhd"); 
let redirecturlsignup = document.createElement('a');
redirecturlsignup.href = "https://kyc.moneysukh.com";
redirecturlsignup.target = '_blank';
redirecturlsignup.style.display = 'none';
document.body.appendChild(redirecturlsignup);
redirecturlsignup.click();
document.body.removeChild(redirecturlsignup); 
    TrackApi(payloadData);
    console.log(error);
})
               }
              
        }else{
            axios.post(`${ApiUrlDomain}/signupnewuser`,{Mobile:MobNumber,mx_Vendor_Unique_Id:""}).then((resurl)=>{
                dispatch(setState({
                    "email": MobNumber,
                    "name": userName
                }));
                localStorage.setItem('userlogin',true);
                localStorage.setItem('email',MobNumber);
                localStorage.setItem('name',userName);
                localStorage.setItem('token',"jhjsdhjhjhd");
                // lead creat api
        let bodydataleadapi=[
            {
            "Attribute": "EmailAddress",
            "Value": ""
            },{
              "Attribute": "Phone",
              "Value": MobNumber
              },{
                "Attribute": "mx_Primary_Email_ID",
                "Value":""
                },{
                  "Attribute": "SearchBy",
                  "Value":"mx_Primary_Email_ID"
                  },
                  {
                    "Attribute": "Source",
                    "Value":"Website"
                    },{
                        "Attribute": "FirstName",
                        "Value":userName
                        },
                        {
                            "Attribute": "mx_Vendor_Unique_Id",
                            "Value":resurl.data.uniqueid
                            },
                        {
                            "Attribute": "mx_website_URL_React",
                            "Value":window.location.href
                            }         
                    
                    ];
          
          
       axios.post(`${ApiUrlDomain}/signupCreateLead`, bodydataleadapi).then(async(responelead)=>{
            console.log("uhhhhhh",responelead);
        //    const leadId=await responelead.data.Message && responelead.data.Message.Id;
           const leadId=responelead && responelead.data&&responelead.data.leadId;
           setCookie('RelatedProspectId', leadId,{ path: '/',"maxAge": 2592000*3 });
           const payloadData={
            "RelatedProspectId":leadId,
            "ActivityNote": "Your Activity Note",
            "mx_Custom_1": "Home",
            "mx_Custom_2": "Your Activity Note",
            "mx_CustomObject_81":window.location.href
           }
        //    TrackApi(payloadData);
        TrackApi(payloadData);
       
          })
        // lead creat api end code
                    // window.open('https://kyc.moneysukh.com');
                    let redirecturlsignup = document.createElement('a');
                    redirecturlsignup.href = resurl.data.data[0].url;
                    redirecturlsignup.target = '_blank';
                    redirecturlsignup.style.display = 'none';
                    document.body.appendChild(redirecturlsignup);
                    redirecturlsignup.click();
                    document.body.removeChild(redirecturlsignup); 
            
                        
                        
            }).catch((error)=>{
                // setverifyloader(false);
                console.log(error);

                dispatch(setState({
                    "email": MobNumber,
                    "name": userName
                }));
                localStorage.setItem('userlogin',true);
                localStorage.setItem('email',MobNumber);
                localStorage.setItem('name',userName);
                localStorage.setItem('token',"jhjsdhjhjhd");
                // lead creat api
        let bodydataleadapi=[
            {
            "Attribute": "EmailAddress",
            "Value": ""
            },{
              "Attribute": "Phone",
              "Value": MobNumber
              },{
                "Attribute": "mx_Primary_Email_ID",
                "Value":""
                },{
                  "Attribute": "SearchBy",
                  "Value":"mx_Primary_Email_ID"
                  },
                  {
                    "Attribute": "Source",
                    "Value":"Website"
                    },{
                        "Attribute": "FirstName",
                        "Value":userName
                        },
                        {
                            "Attribute": "mx_Vendor_Unique_Id",
                            "Value":""
                            } ,
                            
                             {
                            "Attribute": "mx_website_URL_React",
                            "Value":window.location.href
                            }  
                    
                    ];
          
          
       axios.post(`${ApiUrlDomain}/signupCreateLead`, bodydataleadapi).then(async(responelead)=>{
            console.log("uhhhhhh",responelead);
        //    const leadId=await responelead.data.Message && responelead.data.Message.Id;
           const leadId=responelead && responelead.data&&responelead.data.leadId;
           setCookie('RelatedProspectId', leadId,{ path: '/',"maxAge": 2592000*3 });
           const payloadData={
            "RelatedProspectId":leadId,
            "ActivityNote": "Your Activity Note",
            "mx_Custom_1": "Home",
            "mx_Custom_2": "Your Activity Note",
            "mx_CustomObject_81":window.location.href
           }
        //    TrackApi(payloadData);
        TrackApi(payloadData);
       
          })
        // lead creat api end code
                    // window.open('https://kyc.moneysukh.com');
                    let redirecturlsignup = document.createElement('a');
                    redirecturlsignup.href = 'https://kyc.moneysukh.com';
                    redirecturlsignup.target = '_blank';
                    redirecturlsignup.style.display = 'none';
                    document.body.appendChild(redirecturlsignup);
                    redirecturlsignup.click();
                    document.body.removeChild(redirecturlsignup); 
            
                        
                        
           
            })    
       
                // window.open('https://kyc.moneysukh.com/');
            
        }
        
        }).catch((error)=>{
            console.log(error);
        })


    
  }else if(res.data=='Invalid OTP'){
  Swal.fire(`Invalid OTP Please Enter Correct Otp`);
  }
     
      }).catch((error)=>{
          console.log(error);
      })
    //    console.log("fullOtpfullOtp",fullOtp);
    
       

    }
 useEffect(()=>{
    const inputs = document.querySelectorAll('#otp1, #otp2, #otp3, #otp4');
    
    inputs.forEach((input, index) => {
      input.addEventListener('input', () => {
        if (input.value.length === 1 && index < inputs.length - 1) {
          inputs[index + 1].focus();
        }
      });

      input.addEventListener('keydown', (e) => {
        if (e.key === 'Backspace' && !input.value && index > 0) {
          inputs[index - 1].focus();
        }
      });
    }); 
 })
 useEffect(() => {
    let timer;
    if (resendDisabled && seconds > 0) {
      timer = setInterval(() => {
        setSeconds((prev) => prev - 1);
      }, 1000);
    } else if (seconds === 0) {
      setResendDisabled(false);
    }

    return () => clearInterval(timer);
  }, [seconds, resendDisabled]);
    return (
        <>
            <section className="sticky-footer">
                <Container>
                {crntpageurl === "/" ||isSuccess ? (
                 <Row>
                 <Col>
                     <ul>
                         <li>
                             <a href="#">
                                 <span>&#8377;10</span> / Order
                             </a>
                         </li>
                         <li>
                             <a href="#">
                                 <span>&#8377;0</span> Delivery Charges
                             </a>
                         </li>
                         <li style={{ display: isSuccess ? 'none' : 'block' }}>
                             <a href="#">Free Account Opening</a>
                         </li>
                         {/* <li>
                         <form className="stickyfootercta_form">
                         <div class="form-group m-0">
                                 <div class="input-group">
                                     <div class="input-group-prepend">
                                         <div class="input-group-text">+91</div>
                                     </div>
                                     <input type="text" class="form-control" id="EnterMobileNumber" placeholder="Enter your Mobile number" />
                                     <div class="input-group-prepend">
                                     <button type="button" class="btn">{ArrowRight}</button>
                                     </div>
                                 </div>
                             
                         </div>
                     </form>    
                         </li>                             */}
                         <li>
                             <button style={{ display: isSuccess ? 'none' : 'inline-block' }} className="get-started" onClick={() => clickToggleLoginPopup(true)}>Open your account</button>
                         </li>
                         {isSuccess && <li style={{ display: isCRMuser ? 'none' : 'display-block' }} className="trading_ac_new">
                             { ProspectStage=="Customer" &&mx_Lead_Status== "Active" && mx_Status== "Enabled"?<a target="_blank" href=" https://online.moneysukh.com/" className="common_btn w-100">Trade Now</a>:ProspectStage=="Customer" &&mx_Lead_Status== "Ac Closed" && mx_Status== "Closed"?<a target="_blank" href="https://kyc.moneysukh.com/" className="common_btn w-100">Complete your Setup</a>:<a target="_blank" href=" https://kyc.moneysukh.com/" className="common_btn w-100">Complete your Setup</a>}
                         </li>
                         }
                     </ul>
                 </Col>
                 <Col sm={12}>
                     {/* <div className="chatbox_main chatbox-code" dangerouslySetInnerHTML={{ __html: '<span    style="cursor:pointer" onclick="Freshbots.showWidget(true);" >Chat</span>' }} />    */}
                 </Col>
             </Row>
                ) : (
                    <div className="stickyfooter_innerpageform">
                    <div className="stickyfooter_innerpageformslide">
                        <Slider {...settings}>
                            <div className="stickyfooter_innerpageformslidegroup">
                            <div className="stickyfooter_innerpageformslidepanel">
                                {/* alt updated  */}
                                <img src={RupeesFooter10} alt="Order"></img> <span><small>/</small><strong>Order</strong></span>
                            </div>
                            </div>
                            <div className="stickyfooter_innerpageformslidegroup">
                            <div className="stickyfooter_innerpageformslidepanel">
                                <img src={ZeroAmcFooter} alt="amc for first year"></img> <span><strong>AMC</strong> for first year</span>
                            </div>
                            </div>
                            <div className="stickyfooter_innerpageformslidegroup">
                            <div className="stickyfooter_innerpageformslidepanel">
                                <img src={AccountOpenFooter} alt="Free Account Opening"></img> <span><strong>Free Account</strong> Opening</span>
                            </div>
                            </div>
                            <div className="stickyfooter_innerpageformslidegroup">
                            <div className="stickyfooter_innerpageformslidepanel">
                                <img src={AlgoTradingFooter} alt="Free Algo Trading"></img> <span><strong>Free Algo</strong> Trading</span>
                            </div>
                            </div>
                            </Slider>
                    </div>
                    <form className="stickyfooter_innerpageformlist stickyfootercta_form ">
                        <div class={`form-group ${otpfieldenable==true?'d-none':''}`}>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">{UserIcon}</div>
                                </div>
                                <input type="text" class="form-control" id="Name" value={userName} onChange={(e)=>setUserName(e.target.value)} placeholder="Name" />
                            </div>
                        </div>
                        {/* <div class="form-group">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">{EnvelopeIcon}</div>
                                </div>
                                <input type="text" class="form-control" id="Email" placeholder="Email" />
                            </div>
                        </div> */}
                        <div class={`form-group ${otpfieldenable==true?'d-none':''}`}>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">{PhoneIcon}</div>
                                </div>
                                <input type="text" class="form-control" id="Mobile" name="MobNumber" onChange={handleNewUserMobileNumber} value={MobNumber} max={10}  placeholder="Mobile" />
                            </div>
                        </div>

                       {otpfieldenable!=false && <div class={`inputctaopt_grid d-flex align-items-center`}>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"onClick={(e)=>setshowpwdnew(!showpwdnew)}>{showpwdnew?Eye:EyeSlash}</div>
                                    </div>
                                    <div class="inputctaopt_group form-control">
                                    <div className="inputctaopt"> <input size="1" type={showpwdnew?"text":"password"} class="form-control" onChange={(e)=>setotpis1(e.target.value)} id="otp1" maxlength="1" autocomplete="off"/></div>
                                                <div className="inputctaopt"> <input size="1" type={showpwdnew?"text":"password"} class="form-control" onChange={(e)=>setotpis2(e.target.value)} id="otp2" maxlength="1" autocomplete="off"/></div>
                                                <div className="inputctaopt"> <input size="1" type={showpwdnew?"text":"password"} class="form-control" onChange={(e)=>setotpis3(e.target.value)} id="otp3" maxlength="1" autocomplete="off"/></div>
                                                  <div className="inputctaopt"> <input size="1" type={showpwdnew?"text":"password"} class="form-control" onChange={(e)=>setotpis4(e.target.value)} id="otp4" maxlength="1" autocomplete="off"/></div>
                                    </div>
                                    {/* <div class="input-group-prepend">
                                        <div class="input-group-text">
                                            <button type="submit" class="btn btn-primary">{ArrowRight}</button>
                                        </div>
                                    </div> */}
                                </div>
                                <h6 className="otprecvresend_text text-white">{resendDisabled ?  <span>OTP will expire in <strong>{seconds} Sec</strong>.</span> :  <span>Didn’t received? <span  className="resent_otp " onClick={(e)=>OtpSend(e)}>Resend OTP</span></span>}</h6>
                                </div>}
                        <div class="form-group">
                        {otpfieldenable==true?<button type="submit" class="btn btn-primary" onClick={(e)=>verifyOtp(e)}>Verify</button>
                       : <button type="submit" class="btn btn-primary" onClick={(e)=>OtpSend(e)}>Submit</button>}
                        </div>
                    </form>
                </div>
                )}
                   
                   
                    <LoginPopup show={show} ref={childRef} />
                </Container>
            </section>

            <section className="stickyfootercta_mobile" onClick={() => OpenCtaformMobile()}>
                <div className="container">
                {OpenCtaformMobileshow && (
                         <form className="stickyfootercta_form">
                             <div class="form-description input-toggle-fields">
                                <h5>Open Free Demat Account!</h5>
                                <p>Enjoy Zero Brokerage on Equity Delivery<br/> Join our 2.5 Cr+ happy customers</p>
                                </div>
                               {otpfieldenable !=true && <div class="form-group m-0 ">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <div class="input-group-text">+91</div>
                                            </div>
                                            <input type="number" class="form-control" id="EnterMobileNumber" onChange={handleNewUserMobileNumber} value={MobNumber} max={10} placeholder="Enter Mobile number" />
                                           <div class="input-group-prepend">
                                            <button type="button" class="btn" onClick={(e)=>OtpSend(e)}>{ArrowRight}</button>
                                            </div>
                                        </div>
                                </div>}
                                {otpfieldenable==true &&<div class="inputctaopt_grid">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">{EyeSlash}</div>
                                        </div>
                                        <div class="inputctaopt_group form-control">
                                            <div className="inputctaopt"> <input size="1" type="password" class="form-control" id="otp1" maxlength="1"  onChange={(e)=>setotpis1(e.target.value)} autocomplete="off"/></div>
                                            <div className="inputctaopt"> <input size="1" type="password" class="form-control" id="otp2" maxlength="1" onChange={(e)=>setotpis2(e.target.value)} autocomplete="off"/></div>
                                            <div className="inputctaopt"> <input size="1" type="password" class="form-control" id="otp3" maxlength="1" onChange={(e)=>setotpis3(e.target.value)} autocomplete="off"/></div>
                                            <div className="inputctaopt"> <input size="1" type="password" class="form-control" id="otp4" maxlength="1" onChange={(e)=>setotpis4(e.target.value)} autocomplete="off"/></div>
                                        </div>
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">
                                                <button type="submit" class="btn btn-primary" onClick={(e)=>verifyOtp(e)}>{ArrowRight}</button>
                                            </div>
                                        </div>
                                    </div>
                                    </div>}
                                    {otpfieldenable==true &&<h6 className="otprecvresend_text">{resendDisabled ?  <span>OTP will expire in <strong>{seconds} Sec</strong>.</span> :  <span>Didn’t received? <span  className="resent_otp" onClick={(e)=>OtpSend(e)}>Resend OTP</span></span>}</h6>}
                            </form> 
                             )}
                            <button type="button" class="btn">Open FREE DEMAT ACCOUNT</button>
                </div>
            </section>
            {OpenCtaformMobileshow && (
            <div onClick={() => CloseCtaformMobile()} id="overlay"></div>
        )}
        </>
    );
}
export default StickyFooter;